export const HandShakeIcon = (props) => {
  return (
    <svg
      width={props?.width || '17'}
      height={props?.height || '17'}
      viewBox="-0.5 -0.5 18 17.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.0004 5.22435C15.9454 5.51161 15.9072 5.80799 15.8395 6.09069C15.6574 6.81568 15.3186 7.45404 14.8019 8.0468C14.7638 7.98297 14.7426 7.92369 14.7003 7.87809C13.362 6.35515 12.0279 4.82765 10.6897 3.30471C10.2662 2.82138 9.77914 2.80314 9.33022 3.25911C8.64838 3.95219 7.97077 4.64526 7.2847 5.33378C6.84425 5.77607 6.21323 5.80799 5.76008 5.43409C5.50598 5.22435 5.4001 4.95076 5.48904 4.67718C5.52292 4.56775 5.58644 4.45832 5.66691 4.3808C6.67061 3.35031 7.66162 2.30158 8.69497 1.31212C9.96125 0.0946781 11.4435 -0.219941 13.0444 0.350022C14.6113 0.910865 15.5303 2.1511 15.903 3.87011C15.9454 4.06618 15.9665 4.27137 16.0004 4.47199C16.0004 4.72278 16.0004 4.97356 16.0004 5.22435Z"
        fill={props?.color ?? '#E41C19'}
      />
      <path
        d="M8.7415 12.0508C8.82197 10.9291 8.32647 10.3591 7.15336 10.2041C7.08984 8.93195 6.64939 8.42582 5.56098 8.3939C5.54828 8.21151 5.55675 8.02 5.5271 7.84218C5.31535 6.64297 4.00249 6.15053 3.15124 6.96215C2.68539 7.409 2.24071 7.88321 1.78332 8.34374C1.7325 8.3939 1.68592 8.44406 1.63086 8.49877C0.317999 7.19014 -0.283378 5.60792 0.135892 3.71109C0.546691 1.85073 1.66898 0.656085 3.38841 0.209234C5.00196 -0.210259 6.40376 0.309547 7.59381 1.56803C7.30159 1.86897 7.02208 2.15167 6.74256 2.43437C6.26824 2.9177 5.79391 3.39647 5.32382 3.87979C4.68433 4.53183 4.75633 5.43465 5.48475 5.9727C6.1793 6.48339 7.06443 6.40131 7.69968 5.76295C8.35611 5.1018 9.00831 4.43152 9.66474 3.77036C9.69439 3.73844 9.72827 3.70653 9.75791 3.67917C9.94002 3.50134 10.0755 3.5059 10.2492 3.70197C10.5033 3.98467 10.7531 4.27193 11.003 4.55919C12.1507 5.86783 13.2984 7.18102 14.4461 8.48965C14.5435 8.60365 14.6536 8.70396 14.751 8.81339C15.1068 9.21009 15.1534 9.75725 14.8611 10.1494C14.5223 10.6054 13.9083 10.6327 13.5229 10.195C12.9554 9.55663 12.3963 8.90915 11.8331 8.27079C11.1597 7.50476 10.4906 6.73873 9.81721 5.9727C9.77909 5.9271 9.73674 5.87694 9.69015 5.84503C9.57157 5.75383 9.44876 5.76751 9.33864 5.86327C9.23277 5.95902 9.21159 6.12317 9.28782 6.25084C9.31747 6.301 9.35982 6.34659 9.40217 6.39219C10.6261 7.78746 11.85 9.18729 13.074 10.5826C13.561 11.1388 13.3916 11.9641 12.7479 12.183C12.3667 12.3107 12.0533 12.183 11.7865 11.8775C11.1343 11.1297 10.4779 10.3865 9.82568 9.6387C9.24971 8.9821 8.67798 8.33006 8.10201 7.67347C8.07237 7.64155 8.04696 7.60507 8.01308 7.57771C7.89873 7.47284 7.74203 7.4774 7.63616 7.58227C7.53028 7.68259 7.51334 7.85586 7.59804 7.98809C7.63192 8.03824 7.67427 8.08384 7.71662 8.12944C8.94479 9.52927 10.1729 10.9291 11.4011 12.3335C11.6722 12.6435 11.7399 13.0448 11.5832 13.405C11.4308 13.7561 11.1047 13.9704 10.7362 13.9522C10.6769 13.9476 10.6219 13.9339 10.5626 13.9248C10.4101 13.8975 10.3424 13.8245 10.3466 13.633C10.3678 12.7484 9.71556 12.0553 8.8982 12.0645C8.84738 12.0508 8.80079 12.0508 8.7415 12.0508Z"
        fill={props?.color ?? '#E41C19'}
      />
      <path
        d="M8.18658 11.7364C8.18235 12.051 8.09765 12.279 7.91977 12.4614C7.42004 12.9721 6.92454 13.4828 6.41633 13.9843C6.05212 14.34 5.51427 14.3172 5.18817 13.9433C4.8536 13.5649 4.85784 12.9812 5.21782 12.6073C5.71332 12.0921 6.20882 11.5814 6.71702 11.0844C6.99654 10.8108 7.3311 10.7561 7.67838 10.9293C8.01295 11.0981 8.16541 11.399 8.18658 11.7364Z"
        fill={props?.color ?? '#E41C19'}
      />
      <path
        d="M9.77816 13.605C9.78239 13.8831 9.68499 14.1157 9.50288 14.3072C9.01161 14.8088 8.52458 15.3103 8.02485 15.8073C7.6564 16.1721 7.11855 16.1539 6.78398 15.7754C6.44518 15.3924 6.45788 14.8088 6.8221 14.4303C7.30913 13.9242 7.80039 13.4226 8.29589 12.9302C8.57964 12.6475 8.90997 12.5927 9.26572 12.7569C9.58758 12.8982 9.77816 13.2311 9.77816 13.605Z"
        fill={props?.color ?? '#E41C19'}
      />
      <path
        d="M4.98045 8.06175C4.98045 8.3946 4.89998 8.61803 4.73058 8.79586C4.22661 9.31566 3.72264 9.83547 3.2102 10.3416C2.84599 10.6973 2.30814 10.6653 1.98204 10.2869C1.64747 9.90387 1.65594 9.32478 2.01592 8.95089C2.51142 8.43564 3.00692 7.92495 3.51512 7.42795C3.7904 7.15892 4.1165 7.10421 4.45954 7.26836C4.80258 7.43251 4.96775 7.73345 4.98045 8.06175Z"
        fill={props?.color ?? '#E41C19'}
      />
      <path
        d="M3.34961 11.5309C3.34961 11.1844 3.43855 10.9564 3.61218 10.7786C4.11192 10.2679 4.60742 9.75718 5.11562 9.25561C5.47137 8.89996 6.01345 8.93643 6.34379 9.31489C6.66988 9.68878 6.66988 10.2633 6.32261 10.6235C5.82711 11.1433 5.32314 11.6586 4.8107 12.1601C4.53119 12.4337 4.19662 12.4884 3.85358 12.3106C3.52325 12.1419 3.36231 11.8455 3.34961 11.5309Z"
        fill={props?.color ?? '#E41C19'}
      />
    </svg>
  );
};

export const CommentsIcon = (props) => {
  return (
    <svg
      width={props?.width || '18'}
      height={props?.height || '19'}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.286 1.74023H3.71461C2.22306 1.74023 1 2.93612 1 4.39452V11.2115C1 12.6699 2.22306 13.8658 3.71461 13.8658H13.286C14.7776 13.8658 16.0007 12.6699 16.0007 11.2115V4.39452C16.0007 2.93612 14.7776 1.74023 13.286 1.74023ZM11.3556 9.61558H5.64509V8.24052H11.3556V9.61558ZM13.1028 7.1988H3.89785V5.82374H13.1028V7.1988Z"
        fill={props?.color ?? '#5B5B5B'}
      />
      <path
        d="M3.89844 13.3643V16.7394L8.84183 13.3643H3.89844Z"
        fill={props?.color ?? '#5B5B5B'}
      />
    </svg>
  );
};

export const PinnedIcon = (props) => {
  return (
    <svg
      width={props?.width || '26'}
      height={props?.height || '27'}
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_19913_19849)">
        <path
          d="M10.5481 10.0371L7.86375 9.89298L6.59363 11.1631L10.1292 14.6986L6.99922 17.8286L7.07126 19.1708L8.41343 19.2428L11.5434 16.1128L15.0789 19.6484L16.349 18.3783L16.2049 15.6939L20.6504 11.2485L21.3575 11.9556L22.6276 10.6855L15.5565 3.6144L14.2864 4.88453L14.9935 5.59163L10.5481 10.0371Z"
          fill={props?.color ?? '#5B5B5B'}
        />
      </g>
      <defs>
        <clipPath id="clip0_19913_19849">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 25.4558 13.5137)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SuggestedIcon = (props) => {
  return (
    <svg
      width={props?.width || '18'}
      height={props?.height || '19'}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_19913_20219)">
        <path
          d="M8.47266 0.613281V1.70312C8.47266 1.99461 8.70852 2.23047 9 2.23047C9.29148 2.23047 9.52734 1.99461 9.52734 1.70312V0.613281C9.52734 0.321801 9.29148 0.0859375 9 0.0859375C8.70852 0.0859375 8.47266 0.321801 8.47266 0.613281ZM2.14453 9.08594C2.14453 8.79446 1.90867 8.55859 1.61719 8.55859H0.527344C0.235863 8.55859 0 8.79446 0 9.08594C0 9.37742 0.235863 9.61328 0.527344 9.61328H1.61719C1.90867 9.61328 2.14453 9.37742 2.14453 9.08594ZM17.4727 8.55859H16.3828C16.0913 8.55859 15.8555 8.79446 15.8555 9.08594C15.8555 9.37742 16.0913 9.61328 16.3828 9.61328H17.4727C17.7641 9.61328 18 9.37742 18 9.08594C18 8.79446 17.7641 8.55859 17.4727 8.55859ZM2.34281 12.3206L1.42924 12.8479C1.17689 12.9937 1.09037 13.316 1.23613 13.5684C1.38347 13.8228 1.70701 13.9056 1.95659 13.7615L2.87016 13.2341C3.12251 13.0884 3.20903 12.766 3.06327 12.5137C2.91702 12.2613 2.59411 12.1748 2.34281 12.3206ZM15.6572 5.85132L16.5708 5.32397C16.8231 5.17821 16.9096 4.85587 16.7639 4.60352C16.6181 4.35116 16.2942 4.26415 16.0434 4.4104L15.1298 4.93775C14.8775 5.0835 14.791 5.40585 14.9367 5.6582C15.0841 5.91259 15.4076 5.99546 15.6572 5.85132ZM12.762 1.51514L12.2346 2.42871C12.0889 2.68107 12.1754 3.00345 12.4277 3.14917C12.6776 3.29349 13.001 3.21006 13.1482 2.95606L13.6755 2.04249C13.8213 1.79014 13.7348 1.46775 13.4824 1.32203C13.2301 1.17631 12.9077 1.26283 12.762 1.51514ZM4.51758 1.32203C4.26523 1.46779 4.17871 1.79014 4.32446 2.04249L4.85181 2.95606C4.99915 3.21045 5.32269 3.29331 5.57227 3.14917C5.82462 3.00341 5.91114 2.68107 5.76538 2.42871L5.23804 1.51514C5.09178 1.26283 4.76786 1.17631 4.51758 1.32203ZM16.5708 12.8479L15.6572 12.3206C15.4054 12.1748 15.0825 12.2613 14.9368 12.5137C14.791 12.766 14.8775 13.0884 15.1299 13.2341L16.0434 13.7615C16.2933 13.9058 16.6167 13.8224 16.7639 13.5684C16.9096 13.316 16.8231 12.9936 16.5708 12.8479ZM2.87016 4.93775L1.95659 4.4104C1.70476 4.26415 1.38185 4.35116 1.23613 4.60352C1.09041 4.85587 1.17689 5.17825 1.42924 5.32397L2.34281 5.85132C2.59253 5.99556 2.916 5.91242 3.06327 5.6582C3.20899 5.40585 3.12247 5.08347 2.87016 4.93775ZM9 4.35556C6.631 4.35633 4.87522 5.95264 4.39861 7.90251C3.99178 9.56589 4.4666 11.2638 5.66803 12.4447C6.02543 12.7958 6.25131 13.2892 6.32774 13.832H11.6743C11.7549 13.2904 11.9918 12.7857 12.3665 12.4107C13.2563 11.5187 13.7461 10.3379 13.7461 9.08594C13.7461 6.53349 11.7322 4.35486 9 4.35556ZM9 12.7773C8.70877 12.7773 8.47266 12.5412 8.47266 12.25C8.47266 11.9587 8.70877 11.7227 9 11.7227C9.29123 11.7227 9.52734 11.9587 9.52734 12.25C9.52734 12.5412 9.29123 12.7773 9 12.7773ZM9.58451 10.0289L9.52734 10.1406C9.52734 10.4321 9.29148 10.668 9 10.668C8.70852 10.668 8.47266 10.4321 8.47266 10.1406C8.47266 9.64162 8.75591 9.22343 9.19466 9.04885C9.39705 8.96852 9.52734 8.77589 9.52734 8.55859C9.52734 8.26764 9.29095 8.03125 9 8.03125C8.70905 8.03125 8.47266 8.26764 8.47266 8.55859C8.47266 8.85007 8.23679 9.08594 7.94531 9.08594C7.65383 9.08594 7.41797 8.85007 7.41797 8.55859C7.41797 7.68623 8.12763 6.97656 9 6.97656C9.87237 6.97656 10.582 7.68623 10.582 8.55859C10.582 9.21057 10.1906 9.78787 9.58451 10.0289ZM6.36328 15.2611C6.36328 16.8256 7.52147 18.0508 9 18.0508C10.4538 18.0508 11.6367 16.8679 11.6367 15.4141V14.8867H6.36328V15.2611Z"
          fill={props?.color ?? '#5B5B5B'}
        />
      </g>
      <defs>
        <clipPath id="clip0_19913_20219">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.0683594)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RepostedIcon = (props) => {
  return (
    <svg
      width={props?.width || '15'}
      height={props?.height || '13'}
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3958 10.0345L11.9728 12.4575C11.9279 12.5027 11.8745 12.5385 11.8157 12.563C11.7569 12.5874 11.6939 12.6 11.6302 12.6C11.5665 12.6 11.5035 12.5874 11.4447 12.563C11.3859 12.5385 11.3325 12.5027 11.2876 12.4575L8.86461 10.0345C8.79662 9.96685 8.75028 9.8805 8.73145 9.78643C8.71263 9.69236 8.72218 9.59482 8.75889 9.50619C8.79559 9.41756 8.85781 9.34183 8.93763 9.28862C9.01746 9.23541 9.11129 9.20711 9.20722 9.20733H10.1764V2.90758H7.75343C7.62492 2.90755 7.50168 2.85648 7.41082 2.76559L5.47244 0.827205C5.40469 0.759434 5.35855 0.673096 5.33986 0.579108C5.32117 0.485119 5.33077 0.387699 5.36744 0.299163C5.40411 0.210628 5.4662 0.134952 5.54588 0.0817021C5.62555 0.0284526 5.71922 2.04617e-05 5.81505 0H11.1456C12.2146 0 13.084 0.869365 13.084 1.93838V9.20733H14.0532C14.1491 9.20711 14.2429 9.23541 14.3228 9.28862C14.4026 9.34183 14.4648 9.41756 14.5015 9.50619C14.5382 9.59482 14.5478 9.69236 14.529 9.78643C14.5101 9.8805 14.4638 9.96685 14.3958 10.0345ZM9.0129 11.7195L7.12685 9.83391C7.03599 9.74302 6.91275 9.69195 6.78424 9.69192H4.36126V3.39217H5.33045C5.42628 3.39215 5.51995 3.36372 5.59963 3.31047C5.6793 3.25722 5.74139 3.18154 5.77806 3.09301C5.81473 3.00447 5.82433 2.90705 5.80564 2.81307C5.78695 2.71908 5.74081 2.63274 5.67306 2.56497L3.25008 0.141987C3.15921 0.0511389 3.03597 0.000103521 2.90747 0.000103521C2.77898 0.000103521 2.65574 0.0511389 2.56486 0.141987L0.141883 2.56497C0.0741323 2.63274 0.0279956 2.71908 0.00930593 2.81307C-0.00938375 2.90705 0.000212714 3.00447 0.0368821 3.09301C0.0735515 3.18154 0.135647 3.25722 0.21532 3.31047C0.294992 3.36372 0.388664 3.39215 0.484493 3.39217H1.45368V10.6611C1.45368 11.7301 2.32305 12.5995 3.39207 12.5995H8.73232C8.83519 12.5996 8.93542 12.567 9.01851 12.5063C9.1016 12.4456 9.16323 12.3601 9.19447 12.2621C9.22572 12.1641 9.22497 12.0587 9.19233 11.9611C9.15968 11.8636 9.09684 11.7789 9.0129 11.7195Z"
        fill={props?.color ?? '#5B5B5B'}
      />
    </svg>
  );
};

export const QuotedIcon = (props) => {
  return (
    <svg
      width={props?.width || '15'}
      height={props?.height || '16'}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_21034_12677)">
        <path
          d="M5.19226 7.15599H3.17301C2.93261 7.15599 2.72823 7.07188 2.55995 6.90359C2.39176 6.7353 2.30755 6.53099 2.30755 6.29053V6.0022C2.30755 5.36514 2.53295 4.82132 2.98373 4.37054C3.43447 3.91992 3.97839 3.69452 4.61538 3.69452H5.19226C5.34849 3.69452 5.48365 3.6374 5.59789 3.52327C5.71206 3.40906 5.76914 3.2739 5.76914 3.11764V1.96369C5.76914 1.80747 5.71202 1.67217 5.59789 1.55797C5.48369 1.44393 5.34852 1.38672 5.19226 1.38672H4.61538C3.99032 1.38672 3.39399 1.50853 2.82602 1.7518C2.2581 1.99523 1.76688 2.32429 1.35217 2.73901C0.93748 3.15354 0.608516 3.64479 0.365116 4.21277C0.121716 4.78068 0 5.37717 0 6.00216V12.3482C0 12.8292 0.168192 13.2376 0.504734 13.5743C0.841307 13.9108 1.25006 14.079 1.7308 14.079H5.19248C5.67319 14.079 6.08181 13.9108 6.41842 13.5743C6.7549 13.2376 6.92318 12.8292 6.92318 12.3482V8.88678C6.92318 8.40586 6.7549 7.99742 6.4182 7.66072C6.08175 7.32427 5.67297 7.15599 5.19226 7.15599ZM14.4955 7.66072C14.159 7.32427 13.7504 7.15599 13.2696 7.15599H11.2503C11.0101 7.15599 10.8055 7.07188 10.6375 6.90359C10.4691 6.7353 10.3851 6.53099 10.3851 6.29053V6.0022C10.3851 5.36514 10.6105 4.82132 11.061 4.37054C11.5116 3.91992 12.0555 3.69452 12.6928 3.69452H13.2696C13.4258 3.69452 13.5611 3.6374 13.6752 3.52327C13.7893 3.40906 13.8466 3.2739 13.8466 3.11764V1.96369C13.8466 1.80747 13.7893 1.67217 13.6752 1.55797C13.5611 1.44393 13.4259 1.38672 13.2696 1.38672H12.6928C12.0674 1.38672 11.4712 1.50853 10.9031 1.7518C10.3353 1.99523 9.84421 2.32429 9.42949 2.73901C9.01477 3.15354 8.68565 3.64479 8.44234 4.21277C8.19901 4.78068 8.07713 5.37717 8.07713 6.00216V12.3482C8.07713 12.8292 8.24548 13.2376 8.58193 13.5743C8.91841 13.9108 9.32706 14.079 9.80786 14.079H13.2694C13.7502 14.079 14.1588 13.9108 14.4953 13.5743C14.832 13.2376 15 12.8292 15 12.3482V8.88678C15 8.40582 14.832 7.99742 14.4955 7.66072Z"
          fill={props?.color ?? '#5B5B5B'}
        />
      </g>
      <defs>
        <clipPath id="clip0_21034_12677">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.232422)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotIntrestedSadSmileyIcon = (props) => {
  return (
    <svg
    className="svg-icon"
    style={{
      width: "1.6em",
      height: "1.6em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={512} cy={512} r={426.666667} fill="#868585" />
    <path
      d="M362.666667 448m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill="#FFFFFF"
    />
    <path
      d="M661.333333 448m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill="#FFFFFF"
    />
    <path
      d="M512 597.333333a254.165333 254.165333 0 0 0-204.8 102.357334L375.466667 750.933333c32.554667-43.392 82.346667-68.266667 136.533333-68.266666s103.978667 24.874667 136.533333 68.266666l68.266667-51.242666A254.122667 254.122667 0 0 0 512 597.333333z"
      fill="#FFFFFF"
    />
  </svg>
  );
};

export const BlockAndReportIcon = (props) => {
  return (
    <svg
    className="svg-icon"
    style={{
      width: "1.6em",
      height: "1.6em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M512 85.333333c-235.733333 0-426.666667 190.933333-426.666667 426.666667s190.933333 426.666667 426.666667 426.666667 426.666667-190.933333 426.666667-426.666667-190.933333-426.666667-426.666667-426.666667zM170.666667 512c0-188.586667 152.746667-341.333333 341.333333-341.333333 78.933333 0 151.253333 27.093333 209.066667 71.893333l-478.506667 478.506667c-44.8-57.813333-71.893333-130.133333-71.893333-209.066667zM512 853.333333c-78.933333 0-151.253333-27.093333-209.066667-71.893333l478.506667-478.506667c44.8 57.813333 71.893333 130.133333 71.893333 209.066667 0 188.586667-152.746667 341.333333-341.333333 341.333333z"
      fill="#868585"
    />
  </svg>
  );
};

export const DeletePostIcon = (props) => {
  return (
    <svg
      {...props}
      width={props.width || 15}
      height={props.height || 16}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.74212 5.91162C1.74212 8.67826 1.74212 11.4449 1.74212 14.2115C1.74212 15.2705 2.48829 16.0003 3.55701 16.0003C6.18547 16.0003 8.81393 16.0003 11.4472 16.0003C12.5304 16.0003 13.2669 15.2705 13.2669 14.1972C13.2669 11.4354 13.2669 8.67349 13.2669 5.91162C13.2669 5.84961 13.2669 5.7876 13.2669 5.72559C9.41087 5.72559 5.58371 5.72559 1.7373 5.72559C1.74212 5.79714 1.74212 5.85438 1.74212 5.91162ZM6.56578 10.1665C6.18547 9.78968 5.80035 9.40808 5.42004 9.03124C5.14564 8.75935 5.12638 8.4159 5.36708 8.1774C5.60778 7.9389 5.95921 7.95321 6.22879 8.22033C6.64762 8.63533 7.06644 9.05509 7.49488 9.47963C7.54784 9.43193 7.59117 9.39377 7.63449 9.35561C8.01961 8.974 8.40474 8.58763 8.79467 8.20602C9.05463 7.94844 9.40606 7.9389 9.64194 8.17263C9.87783 8.40636 9.86339 8.75458 9.60343 9.01216C9.1798 9.43193 8.75616 9.8517 8.31327 10.2905C8.46732 10.4384 8.61655 10.5767 8.76097 10.7198C9.045 11.0013 9.33384 11.2827 9.61306 11.5641C9.8682 11.8217 9.87783 12.1747 9.63713 12.4037C9.40124 12.6326 9.05463 12.6231 8.79949 12.3703C8.40955 11.9887 8.02443 11.6071 7.63931 11.2207C7.59598 11.1778 7.55265 11.1396 7.4997 11.0871C7.12902 11.4544 6.76797 11.817 6.4021 12.1795C6.32508 12.2558 6.25286 12.3321 6.17103 12.4037C5.93514 12.6183 5.59334 12.6136 5.3719 12.3989C5.14564 12.1795 5.1312 11.8313 5.36227 11.5975C5.76665 11.1825 6.18547 10.7819 6.59466 10.3716C6.61873 10.3478 6.6428 10.3192 6.68131 10.281C6.6428 10.2524 6.60429 10.2047 6.56578 10.1665Z"
        fill={props?.color ?? '#868585'}
      />
      <path
        d="M15 3.50719C14.9952 2.7726 14.509 2.29083 13.7628 2.29083C12.7085 2.29083 11.6494 2.29083 10.5952 2.29083C10.5326 2.29083 10.4652 2.29083 10.3833 2.29083C10.3833 2.06663 10.3882 1.86152 10.3833 1.65164C10.3545 0.769174 9.62273 0.0298129 8.73213 0.0107327C7.91856 -0.00357755 7.10018 -0.00357755 6.28179 0.0107327C5.47785 0.0250429 4.77981 0.630841 4.65465 1.4179C4.61132 1.69934 4.62095 1.98554 4.6017 2.29083C4.52948 2.29083 4.46209 2.29083 4.39469 2.29083C3.32116 2.29083 2.24763 2.28606 1.16929 2.29083C0.572352 2.29083 0.0909494 2.70582 0.0139249 3.283C-0.0101453 3.47857 0.00429682 3.67414 0.00429682 3.86972C0.00429682 4.3658 0.2113 4.57092 0.716773 4.57092C5.23715 4.57092 9.75752 4.57092 14.2731 4.57092C14.3212 4.57092 14.3694 4.57092 14.4175 4.57092C14.74 4.55661 14.9807 4.32287 14.9904 3.99851C15 3.8411 15 3.67414 15 3.50719ZM9.23279 2.28606C8.07261 2.28606 6.9365 2.28606 5.78595 2.28606C5.78595 2.05709 5.76669 1.8329 5.79076 1.61348C5.82446 1.35112 6.06516 1.15555 6.33475 1.15555C7.11462 1.15078 7.89449 1.15078 8.67436 1.15555C8.97283 1.15555 9.21354 1.39405 9.22798 1.68503C9.24242 1.87583 9.23279 2.0714 9.23279 2.28606Z"
        fill={props?.color ?? '#868585'}
      />
    </svg>
  );
};

export const EditPostIcon = (props) => {
  return (
    <svg
      {...props}
      width={props.width || 15}
      height={props.height || 16}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.26329 3.007L1.0101 11.2695C0.968543 11.3112 0.938924 11.3633 0.924335 11.4204L0.00951664 15.096C-0.00393802 15.1506 -0.00311347 15.2077 0.0119106 15.2618C0.0269347 15.3159 0.0556507 15.3653 0.0952846 15.4051C0.156162 15.4658 0.238587 15.4999 0.324537 15.5C0.351052 15.5 0.377464 15.4967 0.403178 15.4902L4.07497 14.5743C4.13206 14.56 4.18418 14.5303 4.22573 14.4886L12.4797 6.2267L9.26329 3.007ZM14.5243 1.88042L13.6056 0.96077C12.9916 0.346105 11.9214 0.346715 11.3081 0.96077L10.1827 2.08735L13.399 5.30693L14.5243 4.18038C14.8311 3.87348 15 3.46495 15 3.03048C15 2.596 14.8311 2.18748 14.5243 1.88042Z"
        fill={props?.color ?? '#868585'}
      />
    </svg>
  );
};

export const PinPostIcon = (props) => {
  return (
    <svg
    className="svg-icon"
    style={{
      width: "1.6em",
      height: "1.6em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M682.666667 512 682.666667 170.666667 725.333333 170.666667 725.333333 85.333333 298.666667 85.333333 298.666667 170.666667 341.333333 170.666667 341.333333 512 256 597.333333 256 682.666667 477.866667 682.666667 477.866667 938.666667 546.133333 938.666667 546.133333 682.666667 768 682.666667 768 597.333333 682.666667 512Z"
      fill="#868585"
    />
  </svg>
  );
};

export const ChnageWhoCanReplyIcon = (props) => {
  return (
    <svg
      {...props}
      width={props.width || 15}
      height={props.height || 16}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2855 0.5H2.71449C1.22301 0.5 0 1.69583 0 3.15417V9.97083C0 11.4292 1.22301 12.625 2.71449 12.625H12.2855C13.777 12.625 15 11.4292 15 9.97083V3.15417C15 1.69583 13.777 0.5 12.2855 0.5ZM10.3551 8.375H4.64489V7H10.3551V8.375ZM12.1023 5.95833H2.89773V4.58333H12.1023V5.95833Z"
        fill={props?.color ?? '#868585'}
      />
      <path
        d="M2.89771 12.125V15.5L7.84089 12.125H2.89771Z"
        fill={props?.color ?? '#868585'}
      />
    </svg>
  );
};

export const MutualConnectionIcon = (props) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_20210_54040)">
        <path
          d="M14.9999 12.2279C14.9765 12.3257 14.9569 12.4275 14.9295 12.5254C14.6673 13.5431 13.7242 14.232 12.6871 14.1733C11.6266 14.1107 10.7774 13.3317 10.6287 12.2827C10.4604 11.0849 11.2861 9.98099 12.4836 9.79701C13.6694 9.61695 14.7886 10.4468 14.9725 11.6485C14.9765 11.6759 14.9921 11.7033 14.9999 11.7307C14.9999 11.8951 14.9999 12.0595 14.9999 12.2279Z"
          fill={props?.color ?? '#747474'}
        />
        <path
          d="M2.19149 9.77345C3.40073 9.76953 4.39082 10.7599 4.39082 11.9733C4.39082 13.1907 3.41247 14.1772 2.19932 14.1772C0.986173 14.1772 0 13.1946 0 11.9812C0 10.7638 0.982259 9.77736 2.19149 9.77345Z"
          fill={props?.color ?? '#747474'}
        />
        <path
          d="M7.49423 0.5C8.70738 0.5 9.69355 1.48252 9.69355 2.69598C9.69355 3.90945 8.7152 4.89588 7.50206 4.89979C6.28891 4.90371 5.30273 3.91728 5.30273 2.70381C5.30273 1.49034 6.28108 0.5 7.49423 0.5Z"
          fill={props?.color ?? '#747474'}
        />
        <path
          d="M4.52393 14.7995C4.66089 14.5255 4.79004 14.275 4.91918 14.0127C6.63715 14.8151 8.3473 14.8191 10.0731 14.0127C10.1396 14.1419 10.2062 14.2671 10.2727 14.3963C10.3353 14.5216 10.3979 14.6468 10.4723 14.7956C8.48818 15.735 6.51975 15.735 4.52393 14.7995Z"
          fill={props?.color ?? '#747474'}
        />
        <path
          d="M11.1217 3.36523C12.9102 4.62176 13.9002 6.32452 14.0881 8.52442C13.7907 8.54008 13.505 8.55574 13.2115 8.57139C13.051 6.67291 12.1901 5.18543 10.6326 4.09723C10.7774 3.87802 10.9182 3.66273 11.0591 3.44744C11.0748 3.42395 11.0943 3.40046 11.1217 3.36523Z"
          fill={props?.color ?? '#747474'}
        />
        <path
          d="M0.911865 8.52443C1.09971 6.32845 2.08979 4.62177 3.88604 3.36133C4.0504 3.61576 4.21085 3.85454 4.3713 4.10507C3.6121 4.61394 3.00944 5.25199 2.55549 6.03487C2.10545 6.81775 1.85499 7.66326 1.79238 8.57532C1.49887 8.55574 1.21711 8.54009 0.911865 8.52443Z"
          fill={props?.color ?? '#747474'}
        />
      </g>
      <defs>
        <clipPath id="clip0_20210_54040">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GIFPlayIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M12.25 15C11.8358 15 11.5 14.6642 11.5 14.25V9.75C11.5 9.33579 11.8358 9 12.25 9C12.6642 9 13 9.33579 13 9.75V14.25C13 14.6642 12.6642 15 12.25 15ZM6 15C5.7 15 5.45833 14.8958 5.275 14.6875C5.09167 14.4792 5 14.25 5 14V10C5 9.75 5.09167 9.52083 5.275 9.3125C5.45833 9.10417 5.7 9 6 9H9C9.3 9 9.54167 9.10417 9.725 9.3125C9.90833 9.52083 10 9.75 10 10C10 10.2761 9.77614 10.5 9.5 10.5H8C7.17157 10.5 6.5 11.1716 6.5 12V12.5C6.5 13.0523 6.94772 13.5 7.5 13.5H7.75C8.16421 13.5 8.5 13.1642 8.5 12.75C8.5 12.3358 8.83579 12 9.25 12C9.66421 12 10 12.3358 10 12.75V14C10 14.25 9.90833 14.4792 9.725 14.6875C9.54167 14.8958 9.3 15 9 15H6ZM15.25 15C14.8358 15 14.5 14.6642 14.5 14.25V11.25C14.5 10.0074 15.5074 9 16.75 9H18.25C18.6642 9 19 9.33579 19 9.75C19 10.1642 18.6642 10.5 18.25 10.5H16.5C16.2239 10.5 16 10.7239 16 11C16 11.2761 16.2239 11.5 16.5 11.5H17.25C17.6642 11.5 18 11.8358 18 12.25C18 12.6642 17.6642 13 17.25 13H17C16.4477 13 16 13.4477 16 14V14.25C16 14.6642 15.6642 15 15.25 15Z"
          fill="white"
        />
      </g>
      <circle
        cx="18"
        cy="18"
        r="17"
        stroke="white"
        stroke-width="2"
        stroke-linecap="square"
        stroke-dasharray="9 9"
      />
    </svg>
  );
};
